import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-20 bg-[#F5F1E8] border-t border-[#EFEBE9] py-6 mt-auto">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright & Social Links */}
          <div className="flex items-center gap-4">
            <div className="text-sm text-[#8D6E63]">
              © {currentYear} Memio. {t('footer.allRightsReserved') || 'All rights reserved.'}
            </div>
            
            {/* Social Media Links */}
            <div className="flex items-center gap-3">
              <a 
                href="https://www.facebook.com/people/Memio/61585321454206/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8D6E63] hover:text-[#1877F2] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/memioinst"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8D6E63] hover:text-[#E4405F] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link 
              to="/privacy" 
              className="text-[#8D6E63] hover:text-[#D4A373] transition-colors"
            >
              {t('footer.privacy') || 'Privacy Policy'}
            </Link>
            <Link 
              to="/terms" 
              className="text-[#8D6E63] hover:text-[#D4A373] transition-colors"
            >
              {t('footer.terms') || 'Terms of Service'}
            </Link>
            <Link 
              to="/faq" 
              className="text-[#8D6E63] hover:text-[#D4A373] transition-colors"
            >
              {t('footer.faq') || 'FAQ'}
            </Link>
            <a 
              href="mailto:support@memio.ca" 
              className="text-[#8D6E63] hover:text-[#D4A373] transition-colors"
            >
              {t('footer.contact') || 'Contact'}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
